export const ROUTES = {
	ADMIN: {
		ROOT: "/admin",
		BRANCHES: "/admin/branches",
		CASES: "/admin/cases",
		BRANCH_DETAIL: (id: string | number) => `/admin/branches/${id}`,
		USERS: "/admin/users",
		USER_DETAIL: (id: string | number) => `/admin/users/${id}`,
		ROLES: "/admin/roles",
		LOGGING: "/admin/logging",
		PAYER_SOURCES: "/admin/payer-sources",
		PAYER_SOURCE_DETAIL: (id: string | number) => `/admin/payer-sources/${id}`,
		PAY_PERIOD_LOCK_TIMES: "/admin/pay-period-lock-times",
		FILE_EXPORT_TYPES: "/admin/file-export-types",
		FILE_IMPORT_TYPES: "/admin/file-import-types",
		VA_MEDICAL_CENTERS: "/admin/va-medical-centers",
		VA_MEDICAL_CENTER_DETAIL: (id: string | number) =>
			`/admin/va-medical-centers/${id}`,
		FEATURE_FLAGS: "/admin/feature-flags",
	},
	ANNOUNCEMENTS: {
		ROOT: "/announcements",
	},
	CASES: {
		ROOT: "/cases",
		CASE_ADMINS: "/cases/case-admins",
		PDF: (id: string | number) => `/cases/${id}/pdf`,
		CASE_MODULES: {
			ROOT: "/cases/case-modules",
			DETAIL: (id: string | number) => `/cases/case-modules/${id}`,
		},
		CASE_TYPES: {
			ROOT: "/cases/case-types",
			DETAIL: (id: string | number) => `/cases/case-types/${id}`,
		},
	},
	CARE_FORMS: {
		ROOT: "/care-forms",
		DETAIL: (id: string | number) => `/care-forms/${id}`,
		CARE_FORM_TYPES: {
			ROOT: "/care-forms/care-form-types",
			DETAIL: (id: string | number) => `/care-forms/care-form-types/${id}`,
		},
	},
	CAREGIVER_APP: {
		ROOT: "/app",
		SHIFT_DEEPLINK: (startTimestamp: string) =>
			`/app?startTimestamp=${startTimestamp}`,
		PICKUP: "/app/pickup",
		CARE_SHEETS: {
			ROOT: "/app/care-sheets",
			REVIEW: (id: string | number) => `/app/care-sheets/${id}/review`,
			SHIFT_CHECKOUT: (
				careSheetId: string | number,
				shiftId: string | number,
			) => `/app/care-sheets/${careSheetId}/shifts/${shiftId}/checkout`,
		},
		FORMS: {
			ROOT: "/app/forms",
			DETAIL: (params: {
				careFormTypeId: number;
				clientId: number;
				payerSourceId: number;
			}) =>
				`/app/forms/detail?careFormTypeId=${params.careFormTypeId}&clientId=${params.clientId}&payerSourceId=${params.payerSourceId}`,
		},
		CARE_PLANS: (id: string | number) => `/app/care-plans/${id}`,
		ONBOARDING: "/app/onboarding",
	},
	CAREGIVERS: {
		ROOT: "/caregivers",
		PROFILE: (id: string | number) => `/caregivers/${id}/profile`,
		SCHEDULE: (id: string | number) => `/caregivers/${id}/schedule`,
		FILE_PREVIEW: (caregiverId: string | number, id: string | number) =>
			`/caregivers/${caregiverId}/files/${id}`,
	},
	CHAT: {
		ROOT: "/chat",
	},
	CLIENTS: {
		ROOT: "/clients",
		PROFILE: (id: string | number) => `/clients/${id}/profile`,
		SCHEDULE: (id: string | number) => `/clients/${id}/schedule`,
		FILE_PREVIEW: (clientId: string | number, id: string | number) =>
			`/clients/${clientId}/files/${id}`,
	},
	DOCS: {
		ROOT: "/docs",
		DOC: (slug: string) => `/docs/${slug}`,
		CHANGELOG: "/docs/changelog",
	},
	DASHBOARD: {
		ROOT: "/dashboard",
		EVV: {
			ROOT: "/dashboard/evv",
			VISITS: "/dashboard/evv",
			CAREGIVERS: "/dashboard/evv?tab=caregivers",
			CLIENTS: "/dashboard/evv?tab=clients",
			TRENDS: "/dashboard/evv?tab=trends",
			CLIENT_DETAIL: (clientId: string | number) =>
				`/dashboard/evv/client/${clientId}`,
			CAREGIVER_DETAIL: (caregiverId: string | number) =>
				`/dashboard/evv/caregiver/${caregiverId}`,
		},
		PERFORMANCE: {
			ROOT: "/dashboard/performance",
			OVERTIME: "/dashboard/performance?tab=overtime",
		},
		ROLLUP: {
			ROOT: "/dashboard/rollup",
		},
		IMPORT: {
			AUTOMATED_DETAIL: (importId: string | number) =>
				`/dashboard/authorizations/automated-imports/${importId}`,
		},
	},
	FILE_EXPORTS: {
		ROOT: "/file-exports",
	},
	FILE_IMPORTS: {
		ROOT: "/file-imports",
		ROWS: "/file-import-rows",
	},
	HOME: {
		ROOT: "/",
	},
	LOGIN: {
		ROOT: "/login",
	},
	MAP: {
		ROOT: "/map",
	},
	MANTINE_DEMO: {
		ROOT: "/mantine-demo",
	},
	NOTIFICATIONS: {
		ROOT: "/notifications",
	},
	TICKETS: {
		ROOT: "/tickets",
		ARCHIVED: "/tickets/archived",
		DETAIL: (id: string | number) => `/tickets/${id}`,
	},
	REPORTS: {
		ROOT: "/reports",
		ADP_EMPLOYEES: "/reports/adp-employees",
		AUTHORIZATION_REVIEW: "/reports/authorization-review",
		BILLING: "/reports/billing",
		CARE_SHEET_FILES: "/reports/care-sheet-files",
		CAREGIVER_CASH_ADVANCES: "/reports/caregiver-cash-advances",
		CAREGIVER_CHANGES: "/reports/caregiver-changes",
		CAREGIVER_FILES: "/reports/caregiver-files",
		CAREGIVER_JOURNALS: "/reports/caregiver-journals",
		CLIENT_AUTHORIZATIONS: "/reports/client-authorizations",
		CLIENT_FILES: "/reports/client-files",

		CLIENT_JOURNALS: "/reports/client-journals",
		INTEGRATION_TRANSACTION_RECORDS: "/reports/integration-transaction-records",
		INTEGRATION_TRANSACTIONS: "/reports/integration-transactions",
		NURSE_ASSESSMENTS: "/reports/nurse-assessments",
		PAYROLL: "/reports/payroll",
		CCW_PEPST_REPORT: "/reports/ccw-pepst-report",
	},
};
